import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cm-case-detail-layout',
  standalone: true,
  templateUrl: './case-detail-layout.component.html',
  styleUrl: './case-detail-layout.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseDetailLayoutComponent {}
